// Module
var code = "edit Template";
// Exports
export default code;